import TrazabilidadRecetasPanel from '../components/TrazabilidadRecetasPanel';
import '../styles/conversaciones-premium.css';
import '../styles/gestion-derivacion-premium.css';
import '../styles/pulse-ledger-premium.css';
import '../styles/farmacia-premium.css';
import '../styles/trazabilidad-recetas-premium.css';

export default function TrazabilidadRecetas() {
  return (
    <section className="crm-gd-page crm-pl-page crm-rtz-page crm-pbody">
      <TrazabilidadRecetasPanel />
    </section>
  );
}
